module.exports = __webpack_public_path__ + "static/img/btn.3f0a6e63.png";